module.exports = __webpack_public_path__ + "static/Gotham-ThinItalic-0adc8a0b375e74de12a6d52badaffa58.ttf";